import { useEffect, useState } from "react";
import api from "../lib/api";

// "2026-10-11T19:23:05+00:00" → "2026-10-11 19:23 UTC"; anything unparseable → "unknown"
export const fmtUtc = (iso) => {
  const d = iso ? new Date(iso) : null;
  if (!d || Number.isNaN(d.getTime())) return "unknown";
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getUTCFullYear()}-${p(d.getUTCMonth() + 1)}-${p(d.getUTCDate())} ${p(d.getUTCHours())}:${p(d.getUTCMinutes())} UTC`;
};

const readOwnBuild = async () => {
  try {
    const r = await fetch(`${process.env.PUBLIC_URL || ""}/version.json`, { cache: "no-store" });
    if (!r.ok) return null;
    const j = await r.json();
    return j && typeof j.build === "string" ? j : null;
  } catch {
    return null;
  }
};

// One small footer line: "Build 7e94991 · 2026-10-11 19:23 UTC · Generator v2 · preview". Fetched once per page load.
// The server's build-time version is the authority (an "unknown" server falls back to the browser's own bundle);
// the browser's bundle (public/version.json) is shown only when it differs, so a stale open tab reads as "(browser …)".
export const BuildVersion = ({ detailed = false, className = "" }) => {
  const [v, setV] = useState(null);
  useEffect(() => {
    let alive = true;
    Promise.all([readOwnBuild(), api.get("/version").then((r) => r.data).catch(() => null)]).then(([fe, be]) => {
      if (alive) setV({ fe, be });
    });
    return () => {
      alive = false;
    };
  }, []);
  if (!v) return null;
  const { fe, be } = v;
  const build = (be?.build !== "unknown" && be?.build) || fe?.build || "unknown";
  const browser = fe?.build && fe.build !== "unknown" ? fe.build : null;
  const builtAt = fmtUtc(be?.built_at || fe?.built_at);
  const parts = [
    `Build ${build}${browser && browser !== build ? ` (browser ${browser})` : ""}`,
    builtAt,
    `Generator ${be?.generator_version || "unknown"}`,
    be?.environment || "unknown",
  ];
  if (detailed) parts.push(`deployed ${fmtUtc(be?.started_at)}`);
  return (
    <p
      data-testid="build-version"
      title={`server started ${fmtUtc(be?.started_at)}`}
      className={`mt-6 text-center text-[11px] leading-relaxed font-mono2 text-accent-strong break-words max-w-full ${className}`}
    >
      {parts.join(" · ")}
    </p>
  );
};
